<script>
    import { onMount } from "svelte";
    import axios from "axios";
    axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
    axios.defaults.xsrfCookieName = "csrf_access_token";

    onMount(async () => {
        await axios
            .get(APIBACKEND + "/discover", { withCredentials: true })
            .then(function (res) {
                discovery = res.data;
            });
    });
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .profile-discover {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-left: var(--spacer-medium);
        padding-right: var(--spacer-medium);

        @include sm {
            margin-top: var(--spacer-large);
            max-width: 712px;
            padding: 0;
        }
    }
</style>

<div class="profile-discover" />
